export enum EndPointEnum {
  DEFAULT,
  BLOG
}
